/* Represent-style Product Page JS */
(function() {
  'use strict';

  /* Image Gallery (legacy single-image swap).
     On the live product page the stacked vertical gallery module in header.js
     rebuilds .rp-gallery before this runs, so the elements queried below are
     gone and this initializer simply no-ops. Kept for safety/other templates. */
  function initGallery() {
    var mainImg = document.querySelector('.rp-gallery__main img');
    var thumbs = document.querySelectorAll('.rp-gallery__thumb');
    var counter = document.querySelector('.rp-gallery__counter-current');
    var prevBtn = document.querySelector('.rp-gallery__nav--prev');
    var nextBtn = document.querySelector('.rp-gallery__nav--next');
    var currentIndex = 0;

    if (!mainImg || !thumbs.length) return;

    function showSlide(index) {
      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;
      currentIndex = index;

      var thumb = thumbs[index];
      var src = thumb.getAttribute('data-full-src') || thumb.querySelector('img').src;
      mainImg.src = src;
      mainImg.style.opacity = '0';
      setTimeout(function() { mainImg.style.opacity = '1'; }, 50);

      thumbs.forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (counter) counter.textContent = index + 1;

      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() { showSlide(i); });
    });

    if (prevBtn) prevBtn.addEventListener('click', function() { showSlide(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { showSlide(currentIndex + 1); });

    var touchStartX = 0;
    var gallery = document.querySelector('.rp-gallery__main');
    if (gallery) {
      gallery.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      gallery.addEventListener('touchend', function(e) {
        var diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) {
          showSlide(diff > 0 ? currentIndex + 1 : currentIndex - 1);
        }
      }, { passive: true });
    }

    if (thumbs[0]) thumbs[0].classList.add('active');
  }

  /* Cart count (real theme header bag) + Checkout button */
  function getCheckoutBtn() {
    var existing = document.querySelector('.rp-checkout-btn');
    if (existing) return existing;
    var atc = document.querySelector('.rp-atc');
    if (!atc || !atc.parentNode) return null;
    var btn = document.createElement('a');
    btn.className = 'rp-checkout-btn';
    btn.href = '/checkout';
    btn.textContent = 'CHECKOUT';
    btn.style.cssText = 'display:none;width:100%;margin-top:1rem;padding:1.6rem 2rem;box-sizing:border-box;text-align:center;text-decoration:none;text-transform:uppercase;letter-spacing:.05em;font-size:1.3rem;font-weight:600;background:#fff;color:#000;border:1.5px solid #000;cursor:pointer';
    atc.parentNode.insertBefore(btn, atc.nextSibling);
    return btn;
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count-bubble').forEach(function(bubble) {
      var spans = bubble.querySelectorAll('span');
      if (spans.length) {
        spans.forEach(function(s) { s.textContent = count; });
      } else {
        bubble.textContent = count;
      }
    });
    document.querySelectorAll('.cart-count-badge, [data-cart-count], .header__cart-count').forEach(function(el) {
      el.textContent = count;
    });
    var btn = getCheckoutBtn();
    if (btn) btn.style.display = count > 0 ? 'block' : 'none';
  }

  function initCart() {
    getCheckoutBtn();
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateCartCount(cart.item_count); })
      .catch(function() {});
  }

  /* Refresh the theme's slide-out cart drawer with fresh section HTML
     returned by /cart/add.js when a `sections` param is sent.
     Without this, the drawer keeps its page-load state (empty for a new
     visitor) even though the header bag count updates — which made the
     cart look empty after adding a product. */
  function refreshCartDrawer(response, opts) {
    opts = opts || {};
    var drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return;
    try {
      if (response && response.sections && response.sections['cart-drawer']) {
        var target = document.getElementById('CartDrawer');
        var fresh = new DOMParser()
          .parseFromString(response.sections['cart-drawer'], 'text/html')
          .querySelector('#CartDrawer');
        if (target && fresh) target.innerHTML = fresh.innerHTML;

        var bubbleTarget = document.getElementById('cart-icon-bubble');
        if (bubbleTarget && response.sections['cart-icon-bubble']) {
          var bubbleDoc = new DOMParser().parseFromString(response.sections['cart-icon-bubble'], 'text/html');
          var bubbleFresh = bubbleDoc.querySelector('.shopify-section') || bubbleDoc.body;
          bubbleTarget.innerHTML = bubbleFresh.innerHTML;
        }

        /* Clear the empty-cart state left over from page load */
        drawerEl.classList.remove('is-empty');
        var inner = drawerEl.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
      }
      if (opts.open && typeof drawerEl.open === 'function') drawerEl.open();
    } catch (err) {
      /* Non-fatal: the bag count still updates via updateCartCount */
    }
  }

  /* Minimal info-column layout: one consistent vertical rhythm, tighter type */
  function injectInfoStyle() {
    if (document.getElementById('rp-info-minimal-style')) return;
    var css = [
      '@media (min-width:990px){.rp-info{padding:3.2rem 4rem 4rem 4rem !important}}',
      '@media (min-width:1200px){.rp-info{padding:3.6rem 5rem 4.5rem 4.5rem !important}}',
      '.rp-breadcrumb{margin-bottom:1.8rem !important;font-size:1.05rem !important}',
      '.rp-title{font-size:2rem !important;line-height:1.2 !important;letter-spacing:.02em !important;margin:0 0 .8rem !important}',
      '.rp-price{font-size:1.4rem !important;margin-bottom:2rem !important}',
      '.rp-colors{margin-bottom:2rem !important}',
      '.rp-model-info{margin-bottom:1.6rem !important}',
      '.rp-sizes{margin-bottom:1.6rem !important}',
      '.rp-atc{height:5rem !important;margin-bottom:.8rem !important}',
      '.rp-checkout-btn{margin-top:0 !important;margin-bottom:1.8rem !important}',
      '.rp-delivery-estimate{padding:.2rem 0 !important;margin-bottom:1.6rem !important;font-size:1.1rem !important}',
      '.rp-whatsapp-inline{height:4.6rem !important;margin-bottom:1.6rem !important}',
      '.rp-trust-row{gap:.6rem !important;margin-bottom:2rem !important;padding-bottom:2rem !important}',
      '.rp-trust-item{font-size:1.1rem !important}',
      '.rp-pk-payments{display:none !important}',
      '.rp-tabs{padding-top:2rem !important}',
      '.rp-tabs__nav{margin-bottom:1.8rem !important}'
    ].join('');
    var s = document.createElement('style');
    s.id = 'rp-info-minimal-style';
    s.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(s);
  }

  /* Stock indicator updater */
  function updateStockIndicator(qty, tracked, available) {
    var indicator = document.querySelector('[data-stock-indicator]');
    if (!indicator) return;
    var textEl = indicator.querySelector('.rp-stock-indicator__text');
    if (!textEl) return;

    var newText;
    var isUrgent = false;

    if (!available) {
      newText = 'OUT OF STOCK';
    } else if (!tracked) {
      newText = 'IN STOCK';
    } else if (qty <= 0) {
      newText = 'OUT OF STOCK';
    } else if (qty <= 5) {
      newText = 'ONLY ' + qty + ' LEFT - ORDER NOW';
      isUrgent = true;
    } else {
      newText = qty + ' IN STOCK';
    }

    textEl.textContent = newText;
    indicator.classList.toggle('rp-trust-item--urgent', isUrgent);
  }

  /* Size Selector */
  function initSizes() {
    var sizeBtns = document.querySelectorAll('.rp-sizes__btn:not(.disabled)');
    var hiddenInput = document.querySelector('.rp-variant-id');

    sizeBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        sizeBtns.forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        if (hiddenInput) {
          hiddenInput.value = btn.getAttribute('data-variant-id');
        }
        var atc = document.querySelector('.rp-atc');
        var available = btn.getAttribute('data-available') === 'true';
        if (atc) {
          atc.disabled = !available;
          atc.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
        }
        var qty = parseInt(btn.getAttribute('data-inventory-qty'), 10) || 0;
        var tracked = btn.getAttribute('data-tracked') === 'true';
        updateStockIndicator(qty, tracked, available);
      });
    });
  }

  /* Tabs (toggle buy section) */
  function initTabs() {
    var navBtns = document.querySelectorAll('.rp-tabs__nav-btn');
    var panels = document.querySelectorAll('.rp-tabs__panel');
    var buySection = document.getElementById('rpBuySection');

    navBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = btn.getAttribute('data-tab');
        var isActive = btn.classList.contains('active');

        navBtns.forEach(function(b) { b.classList.remove('active'); });
        panels.forEach(function(p) { p.classList.remove('active'); });

        if (isActive) {
          closeAllTabs();
        } else {
          btn.classList.add('active');
          var panel = document.querySelector('[data-tab-panel="' + target + '"]');
          if (panel) panel.classList.add('active');
          if (buySection) buySection.style.display = 'none';
        }
      });
    });

    function closeAllTabs() {
      navBtns.forEach(function(b) { b.classList.remove('active'); });
      panels.forEach(function(p) { p.classList.remove('active'); });
      if (buySection) buySection.style.display = '';
    }

    document.querySelectorAll('.rp-tabs__back').forEach(function(btn) {
      btn.addEventListener('click', closeAllTabs);
    });
  }

  /* Color Swatches */
  function initColors() {
    var swatches = document.querySelectorAll('.rp-colors__swatch');
    swatches.forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        var url = swatch.getAttribute('data-url');
        if (url) window.location.href = url;
      });
    });
  }

  /* Add to Cart (AJAX) */
  function initAddToCart() {
    var form = document.querySelector('.rp-product-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantId = form.querySelector('.rp-variant-id');
      if (!variantId || !variantId.value) return;

      var atc = form.querySelector('.rp-atc');
      var originalText = atc.textContent;
      atc.textContent = 'ADDING...';
      atc.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variantId.value),
          quantity: 1,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
      .then(function(r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function(data) {
        atc.textContent = 'ADDED!';
        setTimeout(function() {
          atc.textContent = originalText;
          atc.disabled = false;
        }, 1500);
        /* Sync + open the slide-out cart drawer so it matches the bag count */
        refreshCartDrawer(data, { open: true });
        return fetch('/cart.js');
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) { updateCartCount(cart.item_count); })
      .catch(function() {
        atc.textContent = 'ERROR - TRY AGAIN';
        setTimeout(function() { atc.textContent = originalText; atc.disabled = false; }, 2000);
      });
    });
  }

  /* AJAX Quick-Add from Style With size buttons */
  function initStyleWithQuickAdd() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.rp-style-card__size-btn');
      if (!btn) return;
      if (btn.classList.contains('rp-style-card__size-btn--out')) return;

      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      e.preventDefault();
      e.stopPropagation();

      var original = btn.textContent;
      btn.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variantId),
          quantity: 1,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
      .then(function(r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function(data) {
        btn.textContent = '✓';
        var toast = document.createElement('div');
        toast.style.cssText = 'position:fixed;bottom:2rem;left:50%;transform:translateX(-50%) translateY(2rem);background:#000;color:#fff;padding:1.2rem 2.4rem;font-size:1.2rem;font-weight:500;z-index:10000;opacity:0;transition:opacity .3s,transform .3s;white-space:nowrap;box-shadow:0 4px 20px rgba(0,0,0,.2)';
        toast.textContent = data.title + ' added to bag';
        document.body.appendChild(toast);
        requestAnimationFrame(function() { toast.style.opacity = '1'; toast.style.transform = 'translateX(-50%) translateY(0)'; });
        setTimeout(function() { toast.style.opacity = '0'; setTimeout(function() { toast.remove(); }, 300); }, 2500);

        /* Sync the slide-out cart drawer (keep it closed; the toast confirms) */
        refreshCartDrawer(data);

        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) { updateCartCount(cart.item_count); });

        setTimeout(function() { btn.textContent = original; }, 1500);
      })
      .catch(function() {
        btn.textContent = '!';
        setTimeout(function() { btn.textContent = original; }, 1500);
      });
    });
  }

  /* Size guide modal */
  function initSizeGuide() {
    var modal = document.querySelector('.rp-sizeguide');
    var openBtn = document.querySelector('[data-sizeguide-open]');
    if (!modal || !openBtn) return;

    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('.rp-sizeguide__close');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openBtn.addEventListener('click', open);
    modal.querySelectorAll('[data-sizeguide-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  /* Init */
  function init() {
    injectInfoStyle();
    initSizeGuide();
    initGallery();
    initSizes();
    initTabs();
    initColors();
    initAddToCart();
    initStyleWithQuickAdd();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();